import createCache from '@emotion/cache'
import { CacheProvider, Global, ThemeProvider } from '@emotion/react'
import React from 'react'

import { useCustomer } from '../../../configuration/hooks/useCustomer'
import {
  globalStyles,
  themeHighContrast,
  themeNormal,
} from '../../constants/theme'
import { useHighContrastToggle } from '../../hooks/useHighContrastToggle'
import px2rem from '../../lib/px2rem'

export const ThemeContext = React.createContext<any | undefined>(undefined)

interface Props {
  overrideStyles?: any
}

const ThemeManager: React.FC<React.PropsWithChildren<Props>> = (props) => {
  const { primaryColor } = useCustomer()
  const { isHighContrast } = useHighContrastToggle()
  const [currentTheme, setCurrentTheme] = React.useState(
    isHighContrast
      ? themeHighContrast(primaryColor)
      : themeNormal(primaryColor),
  )
  const { children, overrideStyles } = props
  const styles = globalStyles(currentTheme)
  if (overrideStyles) {
    Object.keys(overrideStyles).forEach((key) => {
      const existingStyle = styles[key]
      styles[key] = {
        ...existingStyle,
        ...overrideStyles[key],
      }
    })
  }
  React.useEffect(() => {
    setCurrentTheme(
      isHighContrast
        ? themeHighContrast(primaryColor)
        : themeNormal(primaryColor),
    )
  }, [isHighContrast, primaryColor])
  return (
    <CacheProvider
      value={createCache({ key: 'cirrusmd-webapp', stylisPlugins: [px2rem] })}
    >
      <ThemeProvider theme={currentTheme}>
        <Global styles={styles} />
        {children}
      </ThemeProvider>
    </CacheProvider>
  )
}

export default ThemeManager
